export const SUCCESS_GET_ADDRESS_BOOK = 'SUCCESS_GET_ADDRESS_BOOK';
export const FAILED_GET_ADDRESS_BOOK = 'FAILED_GET_ADDRESS_BOOK';
export const SUCCESS_DELETE_ADDRESS_BOOK_ENTRY = 'SUCCESS_DELETE_ADDRESS_BOOK_ENTRY';
export const FAILED_DELETE_ADDRESS_BOOK_ENTRY = 'FAILED_DELETE_ADDRESS_BOOK_ENTRY';
export const SUCCESS_UPDATE_ADDRESS_BOOK_ENTRY = 'SUCCESS_UPDATE_ADDRESS_BOOK_ENTRY';
export const FAILED_UPDATE_ADDRESS_BOOK_ENTRY = 'FAILED_UPDATE_ADDRESS_BOOK_ENTRY';



// WEBPACK FOOTER //
// ./src/state/constants/addressBookConstants.js